const printFileFormat = [
  { id: "pdf", title: "PDF" },
  { id: "png", title: "PNG" },
];

export function FileFormatPicker({ selected, setSelected }) {
  return (
    <div>
      <label className="text-base font-semibold text-gray-900">
        Print File Format
      </label>
      <p className="text-sm text-gray-500">
        How do you prefer to send your print files?
      </p>
      <fieldset className="mt-4">
        <legend className="sr-only">Notification method</legend>
        <div className="space-y-4 sm:flex sm:items-center sm:space-x-10 sm:space-y-0">
          {printFileFormat.map((notificationMethod) => (
            <div key={notificationMethod.id} className="flex items-center">
              <input
                onChange={(id) => setSelected(id)}
                id={notificationMethod.id}
                name="notification-method"
                type="radio"
                checked={selected === notificationMethod.id}
                value={notificationMethod.id}
                className="h-4 w-4 border-gray-300 text-indigo-600 focus:ring-indigo-600"
              />
              <label
                htmlFor={notificationMethod.id}
                className="ml-3 block text-sm font-medium leading-6 text-gray-900"
              >
                {notificationMethod.title}
              </label>
            </div>
          ))}
        </div>
      </fieldset>
    </div>
  );
}
